import { E3M3_TO_MCF, M3_TO_BBL } from '../helpers/conversionFactors';

export const convertVolume = (value=30, units='metric', fluid='oil') => { // convert metric to field
  try {
    if (units === 'metric') {
      return value;
    } else {
      return (fluid === 'oil' || fluid === 'condensate' || fluid === 'water') ? (value * M3_TO_BBL) : (value * E3M3_TO_MCF);
    };
  } catch (error) {
    return value;
  };
};

export const revertVolume = (value=30, units='metric', fluid='oil') => { // conert field to metric
  try {
    if (units === 'metric') {
      return value;
    } else {
      return (fluid === 'oil' || fluid === 'condensate' || fluid === 'water') ? (value / M3_TO_BBL) : (value / E3M3_TO_MCF);
    };
  } catch (error) {
    return value;
  };
};